import React from 'react';
import {Filter, TextInput, FilterProps,} from 'react-admin';

const MaterialConfigFilter = (props: Omit<FilterProps, 'children'>) => (
    <Filter {...props}>
        <TextInput source="mattenrand" alwaysOn/>
    </Filter>
);

export default MaterialConfigFilter;
